var _defs, _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e0e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c7d2fe"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "url(#gradientBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4f46e5",
    strokeWidth: 2,
    transform: "translate(125, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 120,
    height: 90,
    rx: 8,
    fill: "#eef2ff",
    stroke: "#6366f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 65,
    r: 20,
    fill: "#c7d2fe",
    stroke: "#4f46e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35,
    width: 15,
    height: 10,
    fill: "#4f46e5"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 230,
    textAnchor: "middle",
    fill: "#3730a3",
    fontFamily: "Segoe UI, sans-serif",
    fontSize: 18
  }, "\n        Product image unavailable.\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.2f7da1f0a5e6baf673ca681fccbaf95b.svg";
export { ForwardRef as ReactComponent };